import _ from 'lodash'
import type {SingleComponentPluginFunction} from '../../types'
import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'

const removeUndefinedProperties = (obj: Record<string, any>) => {
    _.forOwn(obj, (val: any, key: string) => {
        if (_.isPlainObject(val)) {
            removeUndefinedProperties(val)
        } else if (_.isArray(val)) {
            for (const item of val) {
                if (_.isPlainObject(item)) {
                    removeUndefinedProperties(item)
                }
            }
        } else if (val === undefined) {
            delete obj[key]
        }
    })
}

export const pack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems) =>
    removeUndefinedProperties(component)
